module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "has-gradient-background"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "columns is-9 is-variable"
  }, [_c('div', {
    staticClass: "column is-vcentered"
  }, [_c('p', {
    staticClass: "subtitle is-white is-6 is-fullwidth",
    class: {
      'has-text-centered': _vm.$mq.resize && _vm.$mq.below(_vm.$mv.tablet)
    }
  }, [_vm._v("2019 ATD All Copyrights Reserved.")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('figure', {
    staticClass: "image",
    class: _vm.$mq.resize && _vm.$mq.above(_vm.$mv.tablet) ? 'is-pulled-right' : 'is-centered'
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "src": "/fstatic/logo.svg",
      "alt": ""
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e4e1842","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/footer.vue
// module id = 1130
// module chunks = 1